import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ErrorStateService, FacialRecognitionService } from '@fgb/core';
import { firstValueFrom, Subscription } from 'rxjs';

@Component({
  selector: 'fgb-facial-recognition-validating-photo',
  templateUrl: './facial-recognition-validating-photo.component.html',
  styleUrl: './facial-recognition-validating-photo.component.scss',
})
export class FacialRecognitionValidatingPhotoComponent implements OnDestroy {
  @Input() formData: FormControl = new FormControl();
  @Input() stepCounter: number = 3;
  @Output() setStep = new EventEmitter();
  @Output() previousStepChange = new EventEmitter();
  userKey: string = '';
  private routeSub: Subscription;

  constructor(
    private facialRecognitionService: FacialRecognitionService,
    public errorService: ErrorStateService,
    private route: ActivatedRoute
  ) {}

  async validationCheck() {
    this.routeSub = this.route.queryParamMap.subscribe((paramMap) => {
      this.userKey = paramMap.get('key') as string;
    });
    const formData = new FormData();
    formData.append('files', this.formData.value, this.formData.value.name);

    if (this.userKey) {
      await firstValueFrom(this.facialRecognitionService.validateFacialKey(this.userKey))
        .then(async (res) => {
          await firstValueFrom(this.facialRecognitionService.uploadFacialImageWithKey(formData, this.userKey))
            .then((res) => {
              if (res.status === 200) {
                this.setStep.emit(5);
              } else {
                this.addFacialErrors(res);
              }
            })
            .catch((res) => this.addFacialErrors(res));
        })
        .catch((res) => this.addFacialErrors(res));
    } else {
      await firstValueFrom(this.facialRecognitionService.uploadFacialImage(formData))
        .then((res) => {
          if (res.status === 200) {
            this.setStep.emit(5);
          } else {
            this.addFacialErrors(res);
          }
        })
        .catch((res) => this.addFacialErrors(res));
    }
  }

  addFacialErrors(res: any) {
    this.errorService.clearErrors();
    this.errorService.addError(res.error.Code);
    this.setStep.emit(4);
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }
}
